import {Component, HostListener, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss']
})
export class AlertDialogComponent {
    title: string;
    message: string;
    buttonText: string = 'Ok';
    icon: string;

    constructor(public dialogRef: MatDialogRef<AlertDialogComponent>,   @Inject(MAT_DIALOG_DATA) data ) {
      this.title = data.title;
      this.message = data.message;
      if (data.config) {
          this.buttonText = data.config.button ? data.config.button : 'Ok';
          this.icon = data.config.icon ? data.config.icon : null;
      }
    }

    @HostListener('keydown.enter', ['$event']) close(event: KeyboardEvent) {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
        this.dialogRef.close(true);
    }

}
